export default __webpack_public_path__ + "static/media/Jatin Kumar.b4209b52.jpg";